// Fixed-label consent checkbox for informational SMS/messenger messages

import CheckBox from './CheckBox';
import './ConsentCheckBox.scss';

export default function SmsConsentCheckBox({ value, onChange, disabled }) {
  return (
    <CheckBox
      label='I agree to receive information via SMS and messengers'
      className='consent-check-box'
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  );
}
